<template>
  <div>
<!--    <div style="margin: 10px;text-align: center;">-->
<!--      <span>订单数据</span>-->
<!--      <div style="border: 1px solid black;margin-top: 10px;" />-->
<!--    </div>-->
    <div class="content" v-for="item in orderData" :key="item.id">
      <van-row align="center" style="margin-top: 5px;">
        <van-col span="12" style="padding-left: 10px;">
          <span>科室：</span>
          <span>{{ item.creatorDeptName }}</span>
        </van-col>
        <van-col span="12">
          <span>用户：</span>
          <span>{{ item.patientName }}</span>
        </van-col>
      </van-row>
      <van-row align="center" style="margin-top: 10px;">
        <van-col span="12" style="padding-left: 10px;">
          <span>缴费时间：</span>
          <span>{{ $moment(item.payeeTime).format('YYYY-MM-DD HH:mm:ss')}}</span>
        </van-col>
        <van-col span="12" style="padding-left: 10px;">
          <span>编号：</span>
          <span>{{item.medicalAdviceCode}}</span>
        </van-col>
      </van-row>
      <van-row align="center" style="margin-top: 10px;">
        <van-col span="24" style="padding-left: 10px;">
          <span>产品名称：</span>
          <span>{{ item.createUser }}</span>
        </van-col>
      </van-row>
      <van-row align="center" style="margin-top: 10px;border-bottom: 1px solid black;">
        <van-col span="24" style="padding-left: 10px;padding-bottom: 10px;">
          <span>配送信息：</span>
          <span>{{ item.remark }}</span>
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
import {
  hospitalOrders
} from "@/api/prescription/hospitalOrders.js";
import { reactive, toRefs } from "vue";

export default {

  setup() {
    const state = reactive({
      orderData: []
    });

    const getOrder = () => {
      hospitalOrders({}).then((v) => {
        state.orderData = v.data
      })
    }
    getOrder()


    return {
      ...toRefs(state),
    };
  },
};
</script>

